import React from "react";
import { SideMenu } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { BsPlusLg } from "react-icons/bs";
import Hours from "./../../../data/hours";
import Minutes from "./../../../data/minutes";
import "./add-populer-courses.css";
import { MdModeEditOutline } from "react-icons/md";

const Input = styled("input")({
  display: "none",
});

let AddPopulerCourses = () => {
  return (
    <SideMenu>
      <div className="page-data-view-container">
        <br />
        <p className="page-form-heading">Add Populer Courses</p>
        <div className="data-view-card-main">
          <p className="data-view-card-title">Basic Information</p>
        </div>
        <br />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Title</p>
                <input
                  type="text"
                  className="input"
                  placeholder="Your course title"
                />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">subtitle</p>
                <input
                  type="text"
                  className="input"
                  placeholder="Your course subtitle"
                />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Course category</p>
                <select className="input">
                  <option value="">Select..</option>
                  <option value="A1">A1</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Course sub-category</p>
                <select className="input">
                  <option value="">Select..</option>
                  <option value="A1">A1</option>
                </select>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Course topic</p>
                <input
                  type="text"
                  className="input"
                  placeholder="Your course topic"
                />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Course language</p>
                <select className="input">
                  <option value="">Select..</option>
                  <option value="English">English</option>
                  <option value="Urdu">Urdu</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Total Course durations</p>
                <Grid container spacing={2}>
                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div>
                      <select className="input">
                        <option value="">Total hour</option>
                        {Hours.map((hoursValue, hoursIndex) => {
                          return (
                            <option key={hoursIndex} value={hoursValue.hours}>
                              {hoursValue.hours}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </Grid>
                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div>
                      <select className="input">
                        <option value="">Total minute</option>
                        {Minutes.map((minutesValue, minutesIndex) => {
                          return (
                            <option
                              key={minutesIndex}
                              value={minutesValue.minutes}
                            >
                              {minutesValue.minutes}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
          <div className="data-view-card-main">
            <p className="data-view-card-title">Advance Information</p>
          </div>
          <br />
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
              <div>
                <label htmlFor="icon-button-file">
                  <Input accept="image/*" id="icon-button-file" type="file" />
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    className="icon-button-file"
                  >
                    <BsPlusLg color="#7C7C7C" size={30} />
                  </IconButton>
                </label>
              </div>
            </Grid>
            <Grid item xl={9} lg={9} md={9} sm={12} xs={12}>
              <div>
                <p className="upload-file-heading">
                  upload your courses thumbnil Image here
                </p>
                <div>
                  <span className="upload-file-heading">
                    important guidelines:
                  </span>
                  <span className="upload-file-supported-message">
                    1200 x 800 or 12:8 ratio.
                  </span>
                </div>
                <div>
                  <span className="upload-file-heading">suported formate:</span>
                  <span className="upload-file-supported-message">
                    .jpg, .jpeg, or .png
                  </span>
                </div>
                <Button className="upload-file-button" variant="text">
                  Upload Image
                </Button>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Course Description</p>
                <textarea
                  className="textarea"
                  placeholder="Enter your course descriptions"
                  rows="20"
                  cols="40"
                ></textarea>
              </div>
            </Grid>
          </Grid>
          <div className="add-courses-list-main">
            <p className="add-courses-list-heading">
              What you will teach in this course
            </p>
            <Button>
              <p className="add-courses-list-heading">+ Add new</p>
            </Button>
          </div>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">01</p>
                <input
                  type="text"
                  className="input"
                  placeholder="What you will teach in this course ..."
                />
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">02</p>
                <input
                  type="text"
                  className="input"
                  placeholder="What you will teach in this course ..."
                />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Course Start Date</p>
                <input type="date" className="input" />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Course End Date</p>
                <input type="date" className="input" />
              </div>
            </Grid>
          </Grid>
        </Box>
        <div className="add-courses-list-main">
          <p className="input-heading">Set Time</p>
          <Button>
            <p className="add-courses-list-heading">+ Add time</p>
          </Button>
        </div>
        <Grid container spacing={2}>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <div>
              <input type="time" className="input" />
            </div>
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <div>
              <input type="time" className="input" />
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <div>
              <p className="input-heading">How Maney student in class</p>
              <select className="input">
                <option value="">Select..</option>
                <option value="1">1</option>
                <option value="2">2</option>
              </select>
            </div>
          </Grid>
        </Grid>
        <div className="data-view-card-main">
          <p className="data-view-card-title">course module</p>
        </div>
        <div className="add-populer-courses-packege-section">
          <p className="add-populer-courses-packege-heading">
            sections 01:{" "}
            <span className="add-populer-courses-packege-name">
              sections name
            </span>
          </p>
          <div>
            <Button>
              <MdModeEditOutline color="#6B6B6B" size={25} />
            </Button>
            <Button>
              <BsPlusLg color="#545454" size={25} />
            </Button>
          </div>
        </div>
        <br />
        <div className="add-populer-courses-lecture-box">
          <p className="add-populer-courses-lecture-title">Lecture name</p>
          <div>
            <Button>
              <MdModeEditOutline color="#6B6B6B" size={20} />
            </Button>
            <Button>
              <BsPlusLg color="#545454" size={20} />
            </Button>
          </div>
        </div>
        <br />
        <div className="add-populer-courses-lecture-box">
          <p className="add-populer-courses-lecture-title">Lecture name</p>
          <div>
            <Button>
              <MdModeEditOutline color="#6B6B6B" size={20} />
            </Button>
            <Button>
              <BsPlusLg color="#545454" size={20} />
            </Button>
          </div>
        </div>
        <Grid container spacing={2}>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <Button className="form-button" variant="text">
              Add sections
            </Button>
          </Grid>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <div>
              <p className="input-heading">Add price per lasson</p>
              <div className="country-code-picker-main">
                <div className="country-code-picker-dropdown-main">
                  <select className="country-code-picker-dropdown">
                    <option value="$">$</option>
                    <option value="£">£</option>
                    <option value="€">€</option>
                  </select>
                </div>
                <div className="country-flag-main">
                  <input
                    type="number"
                    className="mobile-number-input"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        <div className="add-populer-courses-packege-section">
          <p className="add-populer-courses-packege-heading">Add packeges</p>
          <Button>
            <p className="add-courses-list-heading">+ Add new</p>
          </Button>
        </div>
        <div className="add-populer-courses-packege-section">
          <p className="add-populer-courses-packege-heading">packeges 1</p>
        </div>
        <Grid container spacing={2}>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <div>
              <p className="input-heading">Title</p>
              <input
                type="text"
                className="input"
                placeholder="Your packege title"
              />
            </div>
          </Grid>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <div>
              <p className="input-heading">subTitle</p>
              <input
                type="text"
                className="input"
                placeholder="Your packege subtitle"
              />
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <div>
              <p className="input-heading">Price</p>
              <div className="country-code-picker-main">
                <div className="country-code-picker-dropdown-main">
                  <select className="country-code-picker-dropdown">
                    <option value="$">$</option>
                    <option value="£">£</option>
                    <option value="€">€</option>
                  </select>
                </div>
                <div className="country-flag-main">
                  <input
                    type="number"
                    className="mobile-number-input"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <div>
              <p className="input-heading">Description</p>
              <input
                type="text"
                className="input"
                placeholder="enter your packege description"
              />
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <Button className="form-button" variant="text">
              Add
            </Button>
          </Grid>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
        </Grid>
      </div>
    </SideMenu>
  );
};
export default AddPopulerCourses;
